import $ from 'jquery';

$('.dsp-toggle').on('click', function(e) {

  e.stopPropagation();

  const toggle = $(this);

  const toggleID = toggle.data('toggle-target');
  const toggleGroup = toggle.data('toggle-group');

  $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');

  // all toggles that control this toggleID
  const toggles = $(`[data-toggle-target=${toggleID}]`);
  toggles.each(function() {
    $(this).addClass('is-active');
  });

  const target = $(`#${toggleID}`);
  const targetClass = $(`.${toggleID}`)
  target.addClass('is-active');
  targetClass.each(function() {
    $(this).addClass('is-active');
  })

  const classTarget = $(`.${toggleID}`);
  classTarget.addClass('is-active');

});

$('.dsp-toggle-all-on').on('click', function (e) {
    e.stopPropagation();
    const toggle = $(this);
    const toggleGroup = toggle.data('toggle-group');
    $(`[data-toggle-group=${toggleGroup}]`).addClass('is-active');
});

$('.dsp-toggle-all-off').on('click', function (e) {
    e.stopPropagation();
    const toggle = $(this);
    const toggleGroup = toggle.data('toggle-group');
    $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');
});